// longeva-motion-load.js
// Page-load motion bootstrap. Adds .longeva-motion-ready to <body>
// once DOMContentLoaded fires, which triggers the header reveal animation
// defined in longeva-motion.css. Defers all hero animation to pure CSS.
// ~400 bytes.

(function () {
  'use strict';

  // Add a template-{name} class to <body> so scoped CSS rules in
  // longeva-atmosphere.css (§12, §17) can target a template without
  // relying on Horizon, which does not emit this class. Path-derived
  // so it runs sitewide on every theme load.
  function flipTemplateClass() {
    if (!document.body) return;
    var path = location.pathname;
    var cls = null;
    if (/^\/products\//.test(path)) cls = 'template-product';
    else if (/^\/collections\//.test(path)) cls = 'template-collection';
    else if (/^\/cart/.test(path)) cls = 'template-cart';
    else if (/^\/pages\//.test(path)) cls = 'template-page';
    else if (/^\/blogs\//.test(path)) cls = 'template-blog';
    else if (path === '/' || path === '') cls = 'template-index';
    if (cls && !document.body.classList.contains(cls)) {
      document.body.classList.add(cls);
    }
  }
  if (document.body) flipTemplateClass();
  else document.addEventListener('DOMContentLoaded', flipTemplateClass, { once: true });

  // A11y backfill — patch elements that ship without proper accessible names.
  // Hero image: Horizon's image_tag emits alt from `primary_image.alt` which
  // is often empty for shop-uploaded hero assets. Backfill with section heading.
  // Sticky add-to-cart: the button has no visible text and no aria-label.
  function backfillA11y() {
    if (!document.body) return;

    // 1. Hero image alt
    document.querySelectorAll('.longeva-hero__image, .longeva-hero__picture img').forEach(function (img) {
      if (img.tagName !== 'IMG') return;
      var existing = (img.getAttribute('alt') || '').trim();
      if (existing) return;
      var heading = document.querySelector('.longeva-hero__heading-text, .longeva-hero h1');
      var text = (heading && heading.textContent) ? heading.textContent.trim() : 'Longeva Aesthetics';
      img.setAttribute('alt', text);
    });

    // 2. Sticky add-to-cart button (Horizon emits no aria-label)
    document.querySelectorAll('.sticky-add-to-cart__button').forEach(function (btn) {
      if (!btn.getAttribute('aria-label')) {
        btn.setAttribute('aria-label', 'Add to basket');
      }
    });

    // 3. Slideshow dot buttons (carousel) — ensure accessible names
    document.querySelectorAll('.slideshow-control, .slideshow-controls__dot').forEach(function (b, i) {
      if (!b.getAttribute('aria-label') && !b.textContent.trim()) {
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      }
    });

    // 4. Product card images with empty alt
    document.querySelectorAll('product-card img, .product-card img').forEach(function (img) {
      var existing = (img.getAttribute('alt') || '').trim();
      if (existing) return;
      var titleEl = img.closest('product-card, .product-card');
      var title = titleEl ? titleEl.querySelector('.h4, h3, .product-card__title') : null;
      var text = (title && title.textContent) ? title.textContent.trim() : null;
      if (text) img.setAttribute('alt', text);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', backfillA11y, { once: true });
  } else {
    backfillA11y();
  }
  setTimeout(backfillA11y, 600);
  setTimeout(backfillA11y, 1800);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function ready() {
    document.body.classList.add('longeva-motion-ready');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else {
    ready();
  }
})();
